import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { ContentType, LibOptionValue, TableColumn, TableColumnAction } from 'daisy-design-system-front';
import { DialogService } from '../../../../../services/dialog.service';
import { StationTagsActions } from '../../../../../../store/station-tags/station-tags.actions';

@Injectable({
  providedIn: 'root'
})
export class ExportRequestTagsConfiguration {

  constructor(
    private readonly dialogService: DialogService,
    private readonly router: Router,
    private readonly store: Store,
    private readonly translate: TranslateService
  ) {
  }

  public getTableColumns(): TableColumn[] {
    return [
      { label: this.translate.instant('export-creation.tags.table.columns.name'), fieldName: "displayName", sortable: false, contentType: ContentType.TEXT , fieldId: SortColumnIds.NAME },
      { label: this.translate.instant('export-creation.tags.table.columns.Unity'), fieldName: "unit", sortable: false, contentType: ContentType.TEXT , fieldId: SortColumnIds.UNITY },
      // { label: this.translate.instant('export-creation.tags.table.columns.last-date'), fieldName: "", sortable: true, contentType: ContentType.DATE , fieldId: SortColumnIds.LAST_DATE },
      { label: this.translate.instant('export-creation.tags.table.columns.value-type'), fieldName: "valueType", sortable: false, contentType: ContentType.TEXT , fieldId: SortColumnIds.VALUE_TYPE },
    ];
  }

  private getImplementedTableRowsActions(): Array<TableColumnAction> {
    return [
      {
        label: '',
        iconStyleClass: 'fa-solid fa-gear',
        tooltip: this.translate.instant('export-creation.table.rowActions.setting'),
        callbackFunc: (row: LibOptionValue<string>) => {
          this.store.dispatch(StationTagsActions.search({stationUid: row.value}));

          // this.dialogService.openTagsView()

        },
      },
    ]
  }

}


//*********************************Constants********************************* */

enum SortColumnIds {
  NAME = 'NAME',
  UNITY = 'UNITY',
  LAST_DATE = 'LAST_DATE',
  VALUE_TYPE = 'VALUE_TYPE',
}
